var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUsersIcon = function SvgUsersIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.9 24.98",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.3 1.5c-.6.2-1.1.4-1.7.6-1 .4-1.9 1-2.6 1.7C1.1 4.8.6 6.1.5 7.3q0 1.2.3 2.4c.1.2.1.4.2.6v.1l.1.1h.1s.1 0 .1-.1v-.8c0-.6.2-1.1.4-1.7.2-.5.5-1 .8-1.5.6-.8 1.5-1.3 2.4-1.7.4-.2.8-.3 1.2-.4h0s.1 0 .1.1v.5c0 .1.1.2.3.2q.1 0 .2-.1l2.6-2.1q.15-.15 0-.3h0L6.8.5c-.1 0-.3 0-.4.1 0 0-.1.1-.1.2zM10.9 22.6c.4-.2.8-.4 1.1-.6v-1.9c0-.5-.2-1-.5-1.3-.7-1-1.8-1.6-3-1.9-1.3.7-2.8.7-4.1 0-1.2.3-2.2.9-3 1.9-.3.4-.5.9-.5 1.3V22c.4.2.8.4 1.1.6",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 20.7 9.8 23c-2.1.7-4.4.7-6.5 0l-.1-2.3M21.3 13.6c.4-.2.8-.4 1.1-.6v-1.9c0-.5-.2-1-.5-1.3-.7-1-1.8-1.6-3-1.9-1.3.7-2.8.7-4.1 0-1.2.3-2.2.9-3 1.9-.3.4-.5.9-.5 1.3V13c.4.2.8.4 1.1.6",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3 11.7-.1 2.3c-2.1.7-4.4.7-6.5 0l-.1-2.3M18.7 23.4c.6-.1 1.1-.3 1.6-.6 1-.4 1.9-1 2.6-1.7.9-1 1.5-2.2 1.5-3.5q0-1.2-.3-2.4c-.1-.2-.1-.4-.2-.6v-.1l-.1-.1h-.1s-.1 0-.1.1v.8c0 .6-.2 1.1-.4 1.7-.2.5-.5 1-.8 1.5-.6.8-1.5 1.3-2.4 1.7-.4.2-.8.3-1.2.4h0s-.1 0-.1-.1V20c0-.1-.1-.2-.3-.2q-.1 0-.2.1L15.6 22q-.15.15 0 .3h0l2.6 2.1c.1.1.3.1.4 0 0 0 .1-.1.1-.2zc-.1.1-.1 0 0 0M13.6 3.8C13.6 2 15.1.5 16.9.5s3.3 1.5 3.3 3.3-1.5 3.3-3.3 3.3-3.3-1.5-3.3-3.3M3.2 12.8c0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3-1.5 3.3-3.3 3.3-3.3-1.5-3.3-3.3",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
};
export default SvgUsersIcon;